import React from 'react';

export const scrollHandler = (e: React.MouseEvent<HTMLElement, MouseEvent>, id: string) => {
  const element = document.getElementById(id);
  if (element) {
    e.preventDefault();
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};
